import {
	SEND_MESSAGE,
	SEND_MESSAGE_SUCCESS,
	SEND_MESSAGE_FAIL,
	SEND_MESSAGE_RESET,
} from '../actions/sendMessageAction';

const initialState = {
	apiState: '',
	message: '',
	data: null,
	error: '',
};

const sendMessageReducer = (state = initialState, action) => {
	switch (action.type) {
		case SEND_MESSAGE:
			return {
				...state,
				apiState: 'loading',
			};
		case SEND_MESSAGE_SUCCESS:
			return {
				...state,
				apiState: 'success',
				data: action.response.data,
				message: action.response.message || 'success',
			};
		case SEND_MESSAGE_FAIL:
			return {
				...state,
				apiState: 'error',
				error: action.response.errors || null,
				message: action.response.message || 'error',
			};
		case SEND_MESSAGE_RESET:
			return initialState;
		default:
			return state;
	}
};

export default sendMessageReducer;
